window.addEventListener('DOMContentLoaded', function () {
    let splides = document.querySelectorAll('.projects .splide');

    if (splides.length > 0) {
        for (let i = 0; i < splides.length; i++) {
            let splide = splides[i];

            let splide_slider = new Splide(splide, {
                type: 'list',
                perPage: 3,
                rewind: true,
                arrows: false,
                pagination: true,
                drag: true,
                autoplay: true,
                interval: 5000,
                gap: '20px',
                clones: 2,
                breakpoints: {
                992: {
                    gap: '20px',
                    perPage: 2,
                },
                768: {
                },
                576: {
                    perPage: 1,
                },
            }
            });

            splide_slider.mount();
        }
    }
});
